const es = {
    all: "Todos",
    allFiles: "Todos los archivos",
    allowedTypeFile: "Admite *.jpeg, *.jpg, *.png, *.gif",
    brand: "Marca",
    brandReq: "Debe ser por ejemplo \"Nissan\"",
    bus: "Bus",
    busCreated: "¡Bus creado!",
    busCreatePage: "Bus: Crear nuevo bus",
    busEditPage: "Bus: Editar bus",
    busList: 'Lista de Buses',
    busStation: "Paradero",
    busReport: "Reporte de Bus",
    buses: "Buses",
    busesOnRoute: "Buses en ruta",
    cancel: "Cancelar",
    chooseLang: "Elije un idioma",
    circulationCard: "Tarjeta de Circulación",
    circulationCardRequired: "Fecha de vencimiento de tarjeta de circulación es requerida",
    clear: "Limpiar",
    code: "Código",
    completedLap: "Vuelta completada",
    controlPoints: "Puntos de control",
    create: "Crear",
    createBus: "Crear Bus",
    createDriver: "Crear Conductor",
    createNewBus: "Crear un nuevo bus",
    createNewDriver: "Crear un nuevo conductor",
    control: "Control",
    date: "Fecha",
    day: "Día",
    dayReport: "Reporte del Día",
    delete: "Eliminar",
    deleteBus: "Eliminar bus",
    deleteBusMessage: "¿Está seguro que desea eliminar el bus?",
    deleteBusesMessage: "¿Está seguro que desea eliminar ",
    deleteDriver: "Eliminar conductor",
    deleteDriverMessage: "¿Está seguro que desea eliminar al conductor?",
    deleteDriversMessage: "¿Está seguro que desea eliminar ",
    deleteRoute: "Eliminar ruta",
    demo: "Demo",
    description: "Description",
    disabled: "Deshabilitado",
    dni: "DNI",
    documentNumberHint: "Debe ser 8 dígitos",
    documentNumberRequired: "Debe ser por ejemplo \"70482540\"",
    download: "Descargar",
    downloadBtn: "Descargar",
    downloadControlReport: "Descargar reporte de control",
    downloadReportFull: "Descargar reporte completo",
    driver: "Conductor",
    driverCreated: "¡Conductor creado!",
    driverCreatePage: "Conductor: Crear nuevo conductor",
    driverEditPage: "Conductor: Editar conductor",
    driverLicense: "Brevete",
    driverList: "Lista de Conductores",
    drivers: "Conductores",
    edit: "Editar",
    editBus: "Editar bus",
    editDriver: "Editar Conductor",
    email: "Correo Electrónico",
    enabled: "Habilitado",
    enableDriver: "Habilitar conductor",
    errorUpdatingData: "Error al actualizar datos",
    filters: "Filtros",
    forgotPassword: "¿Olvidaste tu contraseña?",
    friday: "Viernes",
    home: "Inicio",
    historical: "Historico",
    historicalReport: "Reportes: Historico",
    incidents: "Incidencias",
    inputStringMaxSize: "Máximo 150 caracteres",
    insurance: "SOAT",
    dateRequired: "Debe ser por ejemplo \"23/05/2023\"",
    labelCancel: "Cancelar",
    language: "Idioma",
    lap: "Vuelta",
    laps: "Vueltas",
    lastName: "Apellidos",
    lastNameRequired: "Debe ser por ejemplo \"Torres\" o \"Torres Silva\"",
    license: "Licencia",
    licenseExpDate: "Licencia",
    licenseExpDateRequired: "La fecha de caducidad es requerida",
    list: "Lista",
    liveTracking: "Seguimiento",
    login: "Inicio de Sesión",
    logout: "Cerrar Sesión",
    management: "Administración",
    map: "Mapa",
    maxSize: "tamaño maximo de",
    model: "Modelo",
    modelReq: "Debe ser por ejemplo \"Civilian\"",
    monday: "Lunes",
    name: "Nombre",
    nameRequired: "Debe ser por ejemplo \"Carlos\" o \"Carlos Enrique\"",
    newBus: "Nuevo Bus",
    newDriver: "Nuevo Conductor",
    newRoute: "Nueva Ruta",
    no: "No",
    noIncidents: "Sin incidencias",
    noResults: "Sin Resultados",
    onlyLetters: "Debe ser solo letras",
    options: "Opciones",
    others: "Otros",
    owner: "Propietario",
    ownerLastName: "Apellidos del accionista",
    ownerName: "Nombre del accionista",
    password: "Contraseña",
    penalty: "Penalidad",
    phone: "Celular",
    phoneNumberHint: "Debe ser 9 dígitos",
    phoneNumberRequired: "Debe ser por ejemplo \"953654423\"",
    plate: "Placa",
    plateRequired: "Debe ser por ejemplo \"A2A588\"",
    profile: "Perfil",
    lastGeneratedFile: "Último archivo generado",
    registeredBus: "Bus ya registrado",
    registeredDriver: "Conductor ya registrado",
    report: "Reporte",
    reports: "Reportes",
    reportByBus: "Reportes: Por bus",
    reportByDay: "Reportes: Por día",
    role: "Rol",
    roleRequired: "Debe ser por ejemplo \"Chofer\"",
    route: "Ruta",
    routeCreatePage: "Ruta: Crear nueva ruta",
    routeRequired: "La ruta es requerida",
    routes: "Rutas",
    saturday: "Sábado",
    saveChanges: "Guardar Cambios",
    searchBtn: "Buscar",
    search: "Buscar...",
    searchByBusOptions: "Buscar por placa",
    searchByDriverOptions: "Buscar por nombre, placa o numero de celular",
    selectPlateRequired: "Seleccione una placa",
    selectRouteRequired: "Seleccione una ruta",
    selected: "Seleccionados",
    settings: "Ajustes",
    showIncidents: "Mostrar incidencias",
    showTrack: "Mostrar recorrido",
    signIn: "Entrar",
    status: "Estado",
    sunday: "Domingo",
    thursday: "Jueves",
    tuesday: "Martes",
    turnOffAutoTime: "Apagado hora automatica",
    turnOffGps: "Apagado GPS",
    turnOffInternet: "Apagado Internet",
    turnOnAutoTime: "Encido hora automatica",
    turnOnGps: "Encedido GPS",
    turnOnInternet: "Encendido Internet",
    successCreateDriver: "¡Conductor creado!",
    unknown: "Desconocido",
    unknownIncident: "Incidente desconocido",
    uncompletedLap: "Vuelta incompleta",
    updatedBus: "¡Bus actualizado!",
    updatedDriver: "¡Conductor actualizado!",
    updatedDrivers: "¡Conductores actualizados!",
    updatePhoto: "Actualizar foto",
    uploadControlPoints: "Cargar puntos de control",
    uploadFrequency: "Cargar frecuencias",
    uploadPhoto: "Subir foto",
    uploadRoutes: "Cargar rutas",
    wednesday: "Miercoles",
    users: "Usuarios",
    yearProduction: "Año",
    yearProductionRequired: "Debe ser por ejemplo \"2005\"",
    yes: "Si",
    msgInvalidPass: "Contraseña invalida",
    msgUserNotFound: "Usuario no encontrado",
    msgUserTempDisabled: "Su usuario ha sido temporalmente desabilitado por demasiados intentos fallidos. Contacte a su administrador",
    msgErrorFound: "Ops, hubo un error",
    labelSelectRoute: "Seleccione una ruta",
    labelHour: 'Hora',
    labelMonth: "Mes",
    labelPlate: 'Placa',
    labelStatus: 'Estado',
    labelRoute: 'Ruta',
    msgReportDay: "Seleccione el día y la ruta para descargar su reporte",
    msgReportMonth: "Seleccione el mes y el año para mostrar los reportes ya generados",
    msgDeleteRoute: "¿Está seguro que desea eliminar la ruta?",
    titleRouteNotSelected: "No hay rutas seleccionadas",
    msgSelectRoute: "Seleccione una ruta para mostrar resultados",
    frequencies: "Frecuencias",
    information: "Información",
    routeInfoCreated: "¡Información de ruta creada!",
    updatedRouteInfo: "¡Información de ruta actualizada!",
    registeredRouteInfo: "¡Información de ruta ya registrada!",
    variant: "Variante",
    routeCodeRequired: "Debe ser por ejemplo \"1A_CN\" o \"1B_M\"",
    routeCodeHint: "El máximo es 10 caracteres, sin espacios",
    routeNameRequired: "Debe ser por ejemplo \"1A Ciudad Nueva\" o \"1B Miramar\"",
    numberRequired: "Debe ser un número",
    positiveNumberRequired: "Debe ser igual o mayor a 0",
    onlyAlphanumeric: "Solo alfanumerico",
    routeVariantRequired: "Debe ser por ejemplo \"Con estudiantes\" o \"Sin estudiantes\"",
    latitude: "Latitud",
    longitude: "Longitud",
    penalized: "Penalizado",
    visible: "Visible",
    add: "Agregar",
    pointNameRequired: "Debe ser por ejemplo \"Salida\", \"Llegada\" o \"Genovesa\"",
    latitudeHint: "Solo números entre -90 y 90 con máximo 6 decimales",
    longitudeHint: "Solo números entre -180 y 180 con máximo 6 decimales",
    pointsCreated: "¡Puntos creados!",
    pointsCreationFailed: "¡Falló la creación de los puntos!",
    updatedPoints: "¡Puntos actualizados!",
    errorUpdatingPoints: "Error al actualizar puntos",
    restore: "restaurar",
    points: "puntos",
    graceMinutes: "Tolerancias",
    graceMinutesPerLap: "Tolerancias por Vuelta",
    stationLocation: "Ubicación del paradero",
    graceMinutesLimit: "Debe ser menor o igual a la tolerancia por dia",
    pointCodeRequired: "Debe ser por ejemplo \"S\" o \"PXII\"",
    pointCodeHint: "El máximo es 5 caracteres",
    controlTimes: "Tiempos de control",
    range: "Rango",
    start: "Inicio",
    end: "Fin",
    controlTimesCreated: "¡Tiempos de control creados!",
    controlTimesCreationFailed: "¡Falló la creación de tiempos de control!",
    updatedControlTimes: "¡Tiempos de control actualizados!",
    errorUpdatingControlTimes: "Error al actualizar los tiempos de control",
    noChanges: "Sin cambios",
    departurePointHint: "El punto de salida debe ser 0",
    timeReq: "Debe ser una hora",
    startTimeGreaterHint: "Debe ser mayor a la hora de fin anterior",
    startTimeLessHint: "Debe ser menor a la hora de fin",
    endTimeGreaterHint: "Debe ser mayor a la hora de inicio",
    departureTimes: "Tiempos de salida",
    details: "Detalles",
    frequency: "Frecuencia",
    departureTimesCreated: "¡Tiempos de salida creados!",
    departureTimesCreationFailed: "¡Falló la creación de tiempos de salida!",
    updatedDepartureTimes: "¡Tiempos de salida actualizados!",
    errorUpdatingDepartureTimes: "Error al actualizar los tiempos de salida",
    routeCreated: "¡Ruta creada!",
    routeCreationFailed: "¡Falló la creación de ruta!",
    uploadPath: "Cargar Recorrido",
    pathCreated: "¡Recorrido creado!",
    pathCreationFailed: "¡Falló la creación del recorrido!",
    requestDataDeletion: "Solicitar eliminación de datos",
    removeData: "Remover datos",
    userDataRemove: "Eliminar datos de usuario",
    send: "Enviar",
    greetings: "¡Saludos!",
    messageInformative: "Estimado usuario, tus datos personales se eliminarán de forma permanente. Por favor ingrese su número de celular con el que se registro.",
    thanks: "¡Gracias!",
    contactMessage: "En los próximos dias te contactaremos.",
    labelContinue: "Continuar",
    automatedControl: "Control automatizado",
    departures: "Salidas",
    disable: "Deshabilitar",
    updatedDriversFailed: "¡Falló al actualizar conductores!",
    exportDrivers: "Exportar conductores",
    updateDrivers: "Actualizar conductores",
    editRoute: "Editar ruta",
    downloadPath: "Descargar Recorrido",
    errorGetPathFile: "No hay archivo de recorrido",
    pathFileCreationFailed: "¡Falló al crear el archivo del recorrido!",
    controlMode: "Modo de Control",
    selectControlModeRequired: "Seleccione un modo de control",
    announcement: "Anuncio",
    message: "Mensaje",
    announcementCreated: "¡Anuncio creado!",
    announcementCreationFailed: "¡Falló la creación del anuncio!",
    messageRequired: "Se require un mensaje",
    stations: "Paraderos",
    newStation: "Nuevo Paradero",
    stationCreatePage: "Paradero: Crear nuevo paradero",
    stationEditPage: "Paradero: Editar paradero",
    station: "Paradero",
    editStation: "Editar paradero",
    stationNameReq: "Nombre de paradero es requerido",
    expirationDate: "Fecha de expiración",
    stationCodeReq: "Código de paradero es requerido",
    stationCreated: "¡Paradero creado!",
    registeredStation: "¡Paradero ya registrado!",
    unitsPerColumn: "Unidades por columna",
    updatedStation: "¡Paradero actualizado!",
    errorUpdatingStation: "Error al actualizar paradero",
    onlyNumber: "Debe mayor a 0",
    scheduleConfiguration: "Roles: Configuración",
    configuration: "Configuración",
    newSchedule: "Nuevo Rol",
    scheduleCreatePage: "Rol: Crear nuevo rol",
    groups: "Grupos",
    selectGroupRequired: "Seleccione un grupo",
    scheduleSettingsCreated: "¡Ajustes de Rol creado!",
    registeredScheduledSettings: "¡Ajustes de Rol ya registrado!",
}

export default es